export interface SelfEvent {
  event_month: number | null;
  event_day: number | null;
  event_year: number | null;
}

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/** "May 11, 1943 (83)" from the self-contact's birthday event; year/age omitted when unknown. */
export function birthdayLabel(ev: SelfEvent | null | undefined): string | null {
  if (!ev || ev.event_month == null || ev.event_day == null) return null;
  const md = `${MONTHS[ev.event_month - 1] ?? ev.event_month} ${ev.event_day}`;
  if (ev.event_year == null) return md;
  const now = new Date();
  let age = now.getFullYear() - ev.event_year;
  const hadBirthday =
    now.getMonth() + 1 > ev.event_month ||
    (now.getMonth() + 1 === ev.event_month && now.getDate() >= ev.event_day);
  if (!hadBirthday) age -= 1;
  return `${md}, ${ev.event_year} (${age})`;
}
